import { Tooltip } from 'components/ui';
import { PAID_PLAN_TOOLTIP, subscriptionAccess } from 'config.js';
import querystring from 'querystring';
import { Link, useLocation } from 'react-router-dom';
import { useParseURLQueryParams } from 'utils';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

export default function SyncOnceCell({ row }: any) {
  const { storeSubscriptionPlan } = useStoreSubscriptionPlan();
  const location = useLocation();
  const { rawQueryParams } = useParseURLQueryParams();

  const autoSyncLength = row.original?.integrations?.filter(
    (item: any) => item.auto_synced
  ).length;

  return (
    <Tooltip
      text={PAID_PLAN_TOOLTIP}
      disabled={
        !!!(storeSubscriptionPlan < subscriptionAccess.segmentsSyncOnce)
      }
    >
      <Link
        to={{
          pathname: '/customers/segments/integrations',
          search: querystring.stringify({
            store_name: rawQueryParams.store_name,
            segment_name: row.original.segment_name,
          }),
          state: { background: location },
        }}
        className={`border-opacity-20 ${
          autoSyncLength && 'border-segments-accent-color-1 border-opacity-100'
        } inline-block w-segments-182px py-2 font-bold border focus:outline-none rounded-segments-10px  border-black ${
          storeSubscriptionPlan < subscriptionAccess.segmentsLinkToSegment &&
          'pointer-events-none opacity-50'
        }`}
      >
        <div className="flex items-center justify-center space-x-1.5">
          <p
            className={`font-bold text-segments-13px 
               text-segments-accent-color-1
            `}
          >
            {autoSyncLength} Auto synced
          </p>
        </div>
      </Link>
    </Tooltip>
  );
}
